import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgChevronLeft = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.43128 3.3442C9.64616 3.54566 9.65705 3.88316 9.4556 4.09805L5.79756 7.99995L9.4556 11.9018C9.65705 12.1167 9.64616 12.4542 9.43128 12.6557C9.21639 12.8571 8.87887 12.8462 8.67742 12.6314L4.67742 8.36472C4.48509 8.15957 4.48509 7.84034 4.67742 7.63518L8.67742 3.36852C8.87887 3.15363 9.21639 3.14275 9.43128 3.3442Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgChevronLeft)
const IconSvgChevronLeft = createIcon(ForwardRef, 'SvgChevronLeft')
export default IconSvgChevronLeft
